// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3205db65","977":"5b2c6e1f"}[chunkId] + ".chunk.js";
};